import React, { useState, useRef, useEffect } from 'react';
// import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './AnalyticsRealTimeMedia.scss';

import Icon from '../../atoms/Icon/Icon';
import Tooltip from '../../atoms/Tooltip/Tooltip';
import moment from 'moment';

// import Button from '../../../Components/atoms/Button/Button';

// import { NewsroomRequestContext } from '../../../api/context/newsroom-request-context';

// import { createTracker, resetTrackerState } from '../../../api/actions/dashboard-analytics-actions';
import Image from '../../atoms/Image/Image';

// const NewsroomRequestConfirmationPanel = React.lazy(() =>
//   import('../../molecules/NewsroomRequestConfirmationPanel/NewsroomRequestConfirmationPanel')
// );

import Markdown from 'react-markdown';
// import { MathJax, MathJaxContext } from 'better-react-mathjax';
// "better-react-mathjax": "^2.0.3",
import remarkGfm from 'remark-gfm';

import remarkMath from 'remark-math';

const AnalyticsRealTimeMedia = ({
  accessUser,
  analyticsDashboardCard,
  cardType,
  className,
  collectionType,
  dashboardType,
  empty,
  emptyString,
  liveProfile,
  loaded,
  loading,
  media,
  requestReplies,
  setNewsroomName,
  setRequestId,
  setSection,
  setShowReplyPanel,
  setShowMessageNewsroomPanel,
  redact,
  blockClick,
  hideSubMediaData,
  isSubMediaData,
  callCustomCollectionManually,
  updateNewsroomRequestStatus
}) => {
  // const dispatch = useDispatch();
  // const history = useHistory();
  // const navigate = useNavigate();
  const cardType1ModalRef = useRef(null);

  const [showCardType1Modal, setShowCardType1Modal] = useState(false);
  // const [trackerValue, setTrackerValue] = useState('');
  // const [trackerValueType, setTrackerValueType] = useState('');
  const [imgErr, setImgErr] = useState(false);

  // const { userData } = useSelector((state) => state.signInReducer);
  // const isAccessDashboardPremium = userData?.permissions?.includes('User.PREMIUM_PUBLICIST');

  const [viewMoreMessageText, setViewMoreMessageText] = useState(false);

  // const [isThumbUpClicked, setIsThumbUpClicked] = useState(media?.rating === 'up' ? true : false);
  // const [isThumbDownClicked, setIsThumbDownClicked] = useState(
  // media?.rating === 'down' ? true : false
  // );
  // const [sendRatingLoader, setSendRatingLoader] = useState(false);

  // useEffect(() => {
  //   if (media && collectionType === 'custom_associated_replies') {
  //     setIsThumbUpClicked(media?.rating === 'up' ? true : false);
  //     setIsThumbDownClicked(media?.rating === 'down' ? true : false);
  //   }
  // }, [collectionType, media]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        cardType1ModalRef.current &&
        !cardType1ModalRef.current.contains(event.target) &&
        showCardType1Modal
      ) {
        setShowCardType1Modal(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowCardType1Modal, cardType1ModalRef, showCardType1Modal]);

  // if (collectionType === 'messenger_queue') {
  //   // console.log(
  //   //   'customAssociatedReplies',
  //   //   customAssociatedReplies?.results?.every((content) => content.rating === 'up' || 'down') &&
  //   //     customAssociatedReplies?.results?.every((content) => content.rating !== null)
  //   // );
  //   console.log('customAssociatedReplies', customAssociatedReplies);
  //   // console.log('enableResolveButton', enableResolveButton);
  // }

  const tmxMessagesCollTtype =
    collectionType === 'Tmx_messages_cleared' ||
    collectionType === 'Tmx_messages_contact' ||
    collectionType === 'Tmx_messages_expert' ||
    collectionType === 'messenger_queue' ||
    collectionType === 'custom_associated_replies' ||
    collectionType === 'journalist_requests' ||
    collectionType === 'Tmx_messages' ||
    collectionType === 'live_messages' ||
    collectionType === 'replies_to_newsrooms' ||
    collectionType === 'incoming_messages' ||
    collectionType === 'live_replies' ||
    collectionType === 'live_signals';

  const mediaClassName = classNames(className, {
    'tmx-analyticsRealTimeMedia': loading,
    'tmx-analyticsRealTimeMedia--loaded': !loading && loaded,
    'tmx-analyticsRealTimeMedia--cardType0': cardType === 0,
    'tmx-analyticsRealTimeMedia--cardType2': cardType === 2,
    'tmx-analyticsRealTimeMedia--searchCardHeight':
      media?.actionType === 'SEARCH' || collectionType === 'findanyone' || tmxMessagesCollTtype,
    'tmx-analyticsRealTimeMedia--inbox': collectionType === 'inbox',
    'tmx-analyticsRealTimeMedia--profileActivity': collectionType === 'profile_activity',
    'tmx-analyticsRealTimeMedia--profileActivityLive':
      collectionType === 'profile_activity' && media?.profileStatus === 'APPROVED',
    'tmx-analyticsRealTimeMedia--cardType2 withHover':
      cardType === 2 && collectionType === 'new_journalists',
    'tmx-analyticsRealTimeMedia--hideSubMediaData': isSubMediaData
  });

  const isOnTrackerTab = localStorage.getItem('analyticsDashboardTabSelection') === 'tracker';

  const notAccessDashboard = dashboardType !== 'access';
  const isAccessDashboard = dashboardType === 'access';

  const isMessages =
    media.actionType === 'MESSAGES_VIEW' ||
    media.actionType === 'MESSAGES_SENT' ||
    media.actionType === 'MESSAGES_HOVER' ||
    media.actionType === 'MESSAGES_OPEN' ||
    media.actionType === 'CLICKED_MESSAGE_RELEVANT_LINK' ||
    media.actionType === 'CLICKED_MESSAGE_EMAIL' ||
    media.actionType === 'CLICKED_MESSAGE_PHONE' ||
    media.actionType === 'READ_ENTIRE_MESSAGE' ||
    media.actionType === 'VIEW_FULL_MESSAGE' ||
    media.actionType === 'HOVER_MESSAGE_REPLY_CARD' ||
    (media.actionType === 'HOVER_MEDIA_CARD' && media.action === 'quote') ||
    (media.actionType === 'HOVER_MEDIA_CARD' &&
      (media.action === 'expert_comment' || media.action === 'quote'));

  const isReplyOrCommentSent =
    media.actionType === 'REPLY_SENT' || media.actionType === 'QUOTE_SENT';

  const isCommentSent = media.actionType === 'QUOTE_SENT';

  const addImageFallback = (event, type = null) => {
    if (event && event.currentTarget) {
      event.currentTarget.src = '/assets/error-profile-image.webp';
    }
    if (type === 'thumbnail') {
      setImgErr(true);
    }
  };

  const isCardTypeProfileStatus = media?.profileStatus !== null && media?.type === 'PROFILE';

  const isAccessUserAction =
    media.actionType === 'MESSAGES_SENT' ||
    (isCardTypeProfileStatus && media?.profileStatus === 'APPROVED');

  const time = moment
    .utc(media?.timestamp || media?.lastLogin)
    .local()
    .fromNow();
  const timeNumber =
    time.split(' ')[0] === 'an' || time?.split(' ')[0] === 'a' ? '1' : time?.split(' ')[0];
  const timeUnit = time?.split(' ')[1].includes('month')
    ? 'mo'
    : time?.split(' ')[1].includes('few')
    ? 's'
    : time?.split(' ')[1].split('')[0];

  const logintime = moment
    .utc(isMessages || isReplyOrCommentSent ? media?.uploadTime : media?.lastLogin)
    .local()
    .fromNow();

  const loginTimeNumber =
    logintime.split(' ')[0] === 'an' || logintime?.split(' ')[0] === 'a'
      ? '1'
      : logintime?.split(' ')[0];
  const loginTimeUnit = logintime?.split(' ')[1].includes('month')
    ? 'mo'
    : logintime?.split(' ')[1].includes('few')
    ? 's'
    : logintime?.split(' ')[1].split('')[0];

  const initial = media?.companyName?.split(' ')[0].substring(0, 1).toUpperCase();

  //this is a temp const used to not show the TMX company info on Reply to Request cards...
  const isTMXAdminRequest = media.companyName === 'TMX';

  // const notifySent = () => {
  //   setSendRatingLoader(false);
  // };
  const safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;

  function urlTransform(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const tel = value.indexOf('tel');
    const mailto = value.indexOf('mailto');
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');

    if (tel !== -1 || mailto !== -1) {
      // used to allow phone numbers & emails
      return value;
    } else if (
      // If there is no protocol, it’s relative.
      colon === -1 ||
      // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
      (slash !== -1 && colon > slash) ||
      (questionMark !== -1 && colon > questionMark) ||
      (numberSign !== -1 && colon > numberSign) ||
      // It is a protocol, it should be allowed.
      safeProtocol.test(value.slice(0, colon))
    ) {
      return value;
    }

    return '';
  }

  return cardType === 1 && !empty ? (
    <div
      className={mediaClassName}
      onClick={() => {
        // if (expertProfileURL) {
        //   history.push(expertProfileURL);
        // }
      }}
      onKeyDown={() => {
        // if (expertProfileURL) {
        //   history.push(expertProfileURL);
        // }
      }}
      tabIndex={0}
      role="button">
      <div
        className={classNames(
          'tmx-analyticsRealTimeMedia__topCardContainer tmx-analyticsRealTimeMedia__topCardContainer--cardType1',
          {
            'tmx-analyticsRealTimeMedia__topCardContainer--hide': redact
          }
        )}>
        {!loading && (media.orgPic || media.thumbnail) ? (
          <div
            className={classNames(
              'tmx-analyticsRealTimeMedia__profilePicContainerHoverState',
              {
                'tmx-analyticsRealTimeMedia__profilePicContainerHoverState--disableHover': true
              },
              {
                'tmx-analyticsRealTimeMedia__profilePicContainerHoverState--isCommentSent':
                  isCommentSent
              }
            )}
            tabIndex={0}
            role="button">
            <div
              className={classNames('tmx-analyticsRealTimeMedia__profilePicContainer', {
                'tmx-analyticsRealTimeMedia__profilePicContainer--isCommentSent': isCommentSent
              })}>
              <Image
                className={classNames(
                  'tmx-analyticsRealTimeMedia__orgPic',
                  {
                    liveProfile:
                      collectionType === 'profile_activity' && media?.profileStatus === 'APPROVED'
                  },
                  {
                    'tmx-analyticsRealTimeMedia__orgPic--isCommentSent': isCommentSent
                  }
                )}
                src={
                  isCommentSent
                    ? media.thumbnail || '/assets/error-profile-image.webp'
                    : media.orgPic || '/assets/error-profile-image.webp'
                }
                alt="img"
                width="100%"
                height="100%"
              />
            </div>
          </div>
        ) : (
          <div
            className={classNames('tmx-analyticsRealTimeMedia__imgErrHoverState', {
              'tmx-analyticsRealTimeMedia__imgErrHoverState--disableHover':
                isAccessDashboard && collectionType !== 'new_journalists'
            })}
            tabIndex={0}
            role="button">
            <div
              className={classNames(
                'tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--profileCircle tmx-analyticsRealTimeMedia__titleMock--imgErr',
                {
                  'tmx-analyticsRealTimeMedia__titleMock--loading': loading
                }
              )}>
              {initial}
            </div>
          </div>
        )}
        {!isCommentSent ? (
          <div
            className={classNames('tmx-analyticsRealTimeMedia__card1TopTextContainer', {
              'tmx-analyticsRealTimeMedia__card1TopTextContainer--access': isAccessDashboard
            })}>
            {!loading ? (
              <div
                className={classNames(
                  'tmx-analyticsRealTimeMedia__topCardOrgName tmx-analyticsRealTimeMedia__topCardOrgName--lineClamp',
                  {
                    'tmx-analyticsRealTimeMedia__topCardOrgName--disableHover tmx-analyticsRealTimeMedia__topCardOrgName--access':
                      isAccessDashboard
                  },
                  {
                    'tmx-analyticsRealTimeMedia__topCardOrgName--disableHover tmx-analyticsRealTimeMedia__topCardOrgName--profileActivity':
                      collectionType === 'profile_activity'
                  },
                  {
                    'tmx-analyticsRealTimeMedia__topCardOrgName--disableHover': true
                  }
                )}
                tabIndex={0}
                role="button">
                {isCardTypeProfileStatus &&
                (media?.profileStatus === 'PENDING' || media?.profileStatus === 'APPROVED')
                  ? media.companyName
                  : isTMXAdminRequest
                  ? 'TMX ACCESS'
                  : media.companyName}{' '}
                <Icon
                  className="tmx-analyticsRealTimeMedia__verifiedIcon"
                  name="verified"
                  size="micro"
                />
              </div>
            ) : (
              <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--orgName"></div>
            )}
            <div
              className={classNames('tmx-analyticsRealTimeMedia__topCardPersonHoverState', {
                'tmx-analyticsRealTimeMedia__topCardPersonHoverState--disableHover': true
              })}
              tabIndex={0}
              role="button">
              {!loading ? (
                <div
                  className={classNames('tmx-analyticsRealTimeMedia__topCardPersonName', {
                    'tmx-analyticsRealTimeMedia__topCardPersonName--lineClamp': isAccessDashboard,
                    liveProfile:
                      collectionType === 'profile_activity' && media?.profileStatus === 'APPROVED'
                  })}>
                  {collectionType === 'profile_activity' || requestReplies ? (
                    <div>
                      <div className="tmx-analyticsRealTimeMedia__topCardPersonLocation">
                        {isAccessUserAction
                          ? media.profileCreatorName
                          : media.location || media.uploaderLocation}
                      </div>

                      <div
                        className={classNames(
                          'tmx-analyticsRealTimeMedia__absoluteContainer',
                          {
                            'tmx-analyticsRealTimeMedia__absoluteContainer--loading': loading
                          },
                          {
                            ' tmx-analyticsRealTimeMedia__absoluteContainer--profileActivity':
                              collectionType === 'profile_activity'
                          },
                          {
                            ' tmx-analyticsRealTimeMedia__absoluteContainer--requestReplies':
                              requestReplies
                          }
                        )}>
                        {analyticsDashboardCard ? (
                          <div
                            className={classNames(
                              'tmx-analyticsRealTimeMedia__profileNameContainer',
                              {
                                requestReplies,
                                accessUser
                              }
                            )}>
                            {media.contactName}{' '}
                            {accessUser && (
                              <p className="tmx-analyticsRealTimeMedia__accessUserMediaEmail">
                                {media.email}
                              </p>
                            )}
                            {accessUser && (
                              <div className="tmx-analyticsRealTimeMedia__accessUserOnlineContainer">
                                <div className="tmx-analyticsRealTimeMedia__onlineCircle tmx-analyticsRealTimeMedia__onlineCircle--offLine"></div>{' '}
                                <p>
                                  {' '}
                                  Active {loginTimeNumber}
                                  {loginTimeUnit} ago
                                </p>
                              </div>
                            )}
                            {media.isLoggedIn && notAccessDashboard && !accessUser ? (
                              <div className="tmx-analyticsRealTimeMedia__onlineContainer tmx-analyticsRealTimeMedia__onlineContainer--cardType1--analyticsDashboard">
                                <Tooltip direction="left" content="Online">
                                  <div className="tmx-analyticsRealTimeMedia__onlineCircle"></div>
                                </Tooltip>
                                <Tooltip direction="left" content={media.deviceType}>
                                  <div className="tmx-analyticsRealTimeMedia__onlineFont">
                                    {media.deviceType}
                                  </div>
                                </Tooltip>
                              </div>
                            ) : notAccessDashboard && !accessUser ? (
                              <Tooltip content="Offline">
                                <div className="tmx-analyticsRealTimeMedia__onlineCircle tmx-analyticsRealTimeMedia__onlineCircle--offLine"></div>
                              </Tooltip>
                            ) : null}
                          </div>
                        ) : (
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <>
                              <div
                                className={classNames('tmx-analyticsRealTimeMedia__profileTitle', {
                                  hide: isMessages
                                })}>
                                <span className="tmx-analyticsRealTimeMedia__permissionLikely">
                                  <Icon
                                    name={
                                      isCardTypeProfileStatus && media?.profileStatus === 'PENDING'
                                        ? 'clock'
                                        : isCardTypeProfileStatus &&
                                          media?.profileStatus === 'APPROVED'
                                        ? 'check'
                                        : media.actionType === 'CLICKED_EMAIL'
                                        ? 'cliked-email'
                                        : media.actionType === 'CALLED_NUMBER'
                                        ? 'called2'
                                        : media.actionType === 'READ_ENTIRE_BIO' ||
                                          isReplyOrCommentSent
                                        ? 'read-entire'
                                        : media.actionType === 'CLICKED_MEDIA_LINK' ||
                                          media.actionType === 'CLICKED_RELEVANT_LINKS'
                                        ? 'click-link'
                                        : media.actionType === 'WATCHED_SIZZLE'
                                        ? 'sizzle'
                                        : media.actionType === 'OPENED_PROFILE'
                                        ? 'profile1'
                                        : 'views1'
                                    }
                                    iconSize={
                                      isCardTypeProfileStatus && media?.profileStatus === 'PENDING'
                                        ? 'medium'
                                        : isCardTypeProfileStatus &&
                                          media?.profileStatus === 'APPROVED'
                                        ? 'medium'
                                        : 'twenty'
                                    }
                                    className={classNames(
                                      'tmx-analyticsRealTimeMedia__thumbIcon',
                                      {
                                        'tmx-analyticsRealTimeMedia__thumbIcon--viewed':
                                          collectionType === 'profile_activity'
                                      },
                                      {
                                        'tmx-analyticsRealTimeMedia__thumbIcon--green':
                                          isCardTypeProfileStatus &&
                                          media?.profileStatus === 'APPROVED'
                                      }
                                    )}
                                  />
                                  {isReplyOrCommentSent ? (
                                    <p
                                      className={classNames('tmx-analyticsRealTimeMedia__creator')}>
                                      New Request Sent {`${loginTimeNumber}${loginTimeUnit}`} ago
                                    </p>
                                  ) : (
                                    <p
                                      className={classNames('tmx-analyticsRealTimeMedia__creator')}>
                                      {isCardTypeProfileStatus && media?.profileStatus === 'PENDING'
                                        ? 'Pending TMX Review:'
                                        : isCardTypeProfileStatus &&
                                          media?.profileStatus === 'APPROVED'
                                        ? 'New Profile Live:'
                                        : media.actionType === 'CLICKED_EMAIL'
                                        ? 'Clicked your email address'
                                        : media.actionType === 'CALLED_NUMBER'
                                        ? 'Called your number'
                                        : media.actionType === 'READ_ENTIRE_BIO'
                                        ? 'Read your entire bio'
                                        : media.actionType === 'CLICKED_MEDIA_LINK'
                                        ? 'Clicked your social media'
                                        : media.actionType === 'CLICKED_RELEVANT_LINKS'
                                        ? 'Clicked your other media'
                                        : media.actionType === 'WATCHED_SIZZLE'
                                        ? 'Watched your sizzle'
                                        : `${
                                            media.actionType === 'OPENED_PROFILE'
                                              ? 'Opened'
                                              : 'Viewed'
                                          } your profile`}{' '}
                                      {`${timeNumber}${timeUnit}`} ago
                                    </p>
                                  )}
                                </span>
                              </div>
                            </>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : isAccessDashboard ? (
                    <>{isTMXAdminRequest ? 'NATIONAL' : media.location}</>
                  ) : (
                    <>
                      {media.contactName}{' '}
                      {media.isLoggedIn && notAccessDashboard ? (
                        <div className="tmx-analyticsRealTimeMedia__onlineContainer tmx-analyticsRealTimeMedia__onlineContainer--cardType1">
                          <Tooltip direction="left" content="Online">
                            <div className="tmx-analyticsRealTimeMedia__onlineCircle"></div>
                          </Tooltip>
                          <Tooltip direction="left" content={media.deviceType}>
                            <div className="tmx-analyticsRealTimeMedia__onlineFont">
                              {media.deviceType}
                            </div>
                          </Tooltip>
                        </div>
                      ) : notAccessDashboard ? (
                        <Tooltip content="Offline">
                          <div className="tmx-analyticsRealTimeMedia__onlineCircle tmx-analyticsRealTimeMedia__onlineCircle--offLine"></div>
                        </Tooltip>
                      ) : null}
                    </>
                  )}
                </div>
              ) : (
                <div className="tmx-analyticsRealTimeMedia__topCardPersonName">
                  <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--name"></div>
                  <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--onlineCircle"></div>
                </div>
              )}
              {!loading ? (
                collectionType === 'profile_activity' &&
                notAccessDashboard &&
                !analyticsDashboardCard ? (
                  <div className="tmx-analyticsRealTimeMedia__topCardEmail lastActive">
                    <Tooltip direction="left" content="Online">
                      <div className="tmx-analyticsRealTimeMedia__onlineCircle tmx-analyticsRealTimeMedia__onlineCircle--offLine"></div>
                    </Tooltip>{' '}
                    Active in the last {loginTimeNumber}
                    {loginTimeUnit}
                  </div>
                ) : notAccessDashboard && !analyticsDashboardCard ? (
                  <div className="tmx-analyticsRealTimeMedia__topCardEmail">{media.email}</div>
                ) : null
              ) : (
                <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--email"></div>
              )}

              {isMessages && (
                <div>
                  {/* <>{media.location}</> */}
                  <div className="tmx-analyticsRealTimeMedia__newsrommMessagesViewContainer">
                    <Icon
                      name={
                        media.actionType === 'MESSAGES_SENT'
                          ? 'check'
                          : media.actionType === 'MESSAGES_OPEN'
                          ? 'opened'
                          : media.actionType === 'CLICKED_MESSAGE_RELEVANT_LINK'
                          ? 'click-link'
                          : media.actionType === 'CLICKED_MESSAGE_PHONE'
                          ? 'called2'
                          : media.actionType === 'CLICKED_MESSAGE_EMAIL'
                          ? 'cliked-email'
                          : media.actionType === 'READ_ENTIRE_MESSAGE'
                          ? 'read-entire'
                          : media.actionType === 'VIEW_FULL_MESSAGE'
                          ? 'read-entire'
                          : 'views1'
                      }
                      iconSize={media.actionType === 'MESSAGES_SENT' ? 'medium' : 'huge'}
                      className={classNames(
                        'tmx-analyticsRealTimeMedia__thumbIcon',
                        {
                          'tmx-analyticsRealTimeMedia__thumbIcon--viewed':
                            collectionType === 'profile_activity'
                        },
                        {
                          'tmx-analyticsRealTimeMedia__thumbIcon--green':
                            media.actionType === 'MESSAGES_SENT'
                        }
                      )}
                    />

                    <p className="tmx-analyticsRealTimeMedia__newsrommMessagesView">
                      {' '}
                      {isReplyOrCommentSent
                        ? 'New Request Sent '
                        : media.actionType === 'CLICKED_MESSAGE_RELEVANT_LINK'
                        ? 'Clicked your relevant link '
                        : media.actionType === 'CLICKED_MESSAGE_EMAIL'
                        ? 'Clicked your email address '
                        : media.actionType === 'CLICKED_MESSAGE_PHONE'
                        ? 'Called your number '
                        : media.actionType === 'READ_ENTIRE_MESSAGE'
                        ? 'Read your entire message '
                        : media.actionType === 'VIEW_FULL_MESSAGE' &&
                          (media.action === 'expert_comment' || media.action === 'quote')
                        ? 'Read your entire comment '
                        : media.actionType === 'VIEW_FULL_MESSAGE'
                        ? 'Read your entire reply '
                        : media.actionType === 'HOVER_MESSAGE_REPLY_CARD'
                        ? 'Viewed your reply '
                        : media.actionType === 'HOVER_MEDIA_CARD' && media.action === 'quote'
                        ? 'Viewed your comment '
                        : media.actionType === 'HOVER_MEDIA_CARD' &&
                          (media.action === 'expert_comment' || media.action === 'quote')
                        ? 'Viewed your comment '
                        : media.actionType === 'MESSAGES_SENT'
                        ? 'New Pitch Sent '
                        : `${
                            media.actionType === 'MESSAGES_OPEN' ? 'Opened' : 'Viewed'
                          } your pitch `}
                      {timeNumber}
                      {timeUnit} ago
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            {!loading ? (
              <div
                // onClick={() => history.push(`details?cId=${media.requestId}`)}
                // onKeyDown={() => history.push(`details?cId=${media.requestId}`)}
                tabIndex={0}
                role="button"
                className="tmx-analyticsRealTimeMedia__commentTopSectionContainer">
                <div className="tmx-analyticsRealTimeMedia__commentSentTitle">{media.title}</div>
                <div className="tmx-analyticsRealTimeMedia__commentSentTimeStamp">
                  Story posted {`${loginTimeNumber}${loginTimeUnit}`} ago
                </div>
              </div>
            ) : (
              <div>
                <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--orgName"></div>
                <div className="tmx-analyticsRealTimeMedia__topCardPersonName">
                  <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--name"></div>
                  <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--onlineCircle"></div>
                </div>
                <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--email"></div>
              </div>
            )}
          </>
        )}
      </div>
      <div
        className={classNames('tmx-analyticsRealTimeMedia__divider', {
          'tmx-analyticsRealTimeMedia__divider--hide': redact
        })}></div>
      {!loading ? (
        collectionType === 'findanyone' || tmxMessagesCollTtype ? (
          <>
            <div
              className={classNames(
                'tmx-analyticsRealTimeMedia__searchedTextContainer tmx-analyticsRealTimeMedia__searchedTextContainer--column',
                {
                  'tmx-analyticsRealTimeMedia__searchedTextContainer--journalistRequests':
                    collectionType === 'journalist_requests' && isAccessDashboard,
                  'tmx-analyticsRealTimeMedia__searchedTextContainer--reply':
                    media.role === 'REPLY' && collectionType === 'live_replies'
                }
              )}
              to={'#'}
              onMouseUp={() => {}}
              onClick={() => {
                if (collectionType === 'journalist_requests' && isAccessDashboard) {
                  setNewsroomName(media?.companyName);
                  setRequestId(media?.requestId);
                  setShowReplyPanel(true);
                }
              }}
              onKeyDown={() => {
                if (collectionType === 'journalist_requests' && isAccessDashboard) {
                  setNewsroomName(media?.companyName);
                  setRequestId(media?.requestId);
                  setShowReplyPanel(true);
                }
              }}
              tabIndex={0}
              role="button">
              <div
                className={classNames('tmx-analyticsRealTimeMedia__searchedTextContainer', {
                  'tmx-analyticsRealTimeMedia__searchedTextContainer--messages':
                    tmxMessagesCollTtype,
                  'tmx-analyticsRealTimeMedia__searchedTextContainer--reply':
                    media.role === 'REPLY' && collectionType === 'live_replies'
                })}>
                <Icon
                  name={
                    collectionType === 'findanyone'
                      ? 'search'
                      : media.actionType === 'INVITES'
                      ? 'contacts'
                      : 'send'
                  }
                  iconSize="twenty"
                  className={classNames(
                    'tmx-analyticsRealTimeMedia__thumbIcon',
                    {
                      'tmx-analyticsRealTimeMedia__thumbIcon--searched':
                        collectionType === 'findanyone'
                    },
                    {
                      'tmx-analyticsRealTimeMedia__thumbIcon--messages': tmxMessagesCollTtype
                    },
                    {
                      'tmx-analyticsRealTimeMedia__thumbIcon--invite':
                        media.actionType === 'INVITES'
                    }
                  )}
                />
                <p className="tmx-analyticsRealTimeMedia__searchedTextDetails">
                  {collectionType === 'live_signals'
                    ? 'Signal generated'
                    : collectionType === 'findanyone'
                    ? 'Searched'
                    : media.actionType === 'INVITES'
                    ? 'Invited'
                    : 'Chat'}{' '}
                  {media.actionType === 'INVITES'
                    ? `${timeNumber}${timeUnit} ago:`
                    : `${timeNumber}${timeUnit} ago `}
                </p>
              </div>

              <div className="tmx-analyticsRealTimeMedia__listCOntainerPadding">
                {collectionType === 'findanyone' ? (
                  <ul className="tmx-analyticsRealTimeMedia__listCOntainer">
                    {Object.entries(media.searchedFields).map(
                      ([key, value], ind) =>
                        value && (
                          <li className="tmx-analyticsRealTimeMedia__listItems" key={ind}>
                            {key}: {value}
                          </li>
                        )
                    )}
                  </ul>
                ) : collectionType === 'Tmx_messages_expert' ||
                  collectionType === 'messenger_queue' ||
                  collectionType === 'custom_associated_replies' ||
                  collectionType === 'replies_to_newsrooms' ||
                  collectionType === 'incoming_messages' ||
                  collectionType === 'journalist_requests' ? (
                  <ul id={media?.id} className="tmx-analyticsRealTimeMedia__listCOntainer">
                    {Object.entries(media.requestExpert).map(
                      ([key, value], ind) =>
                        value && (
                          <li className="tmx-analyticsRealTimeMedia__listItems" key={ind}>
                            <span>{key}</span>:{' '}
                            {collectionType === 'Tmx_messages_expert' ||
                            collectionType === 'messenger_queue' ||
                            collectionType === 'custom_associated_replies' ||
                            collectionType === 'replies_to_newsrooms' ||
                            collectionType === 'incoming_messages' ? (
                              <span
                                className={classNames({
                                  'tmx-analyticsRealTimeMedia__dangerouslyInnerHtmlContent':
                                    media?.requestExpert?.Description?.length > 200 &&
                                    key === 'Description',
                                  'tmx-analyticsRealTimeMedia__dangerouslyInnerHtmlContent tmx-analyticsRealTimeMedia__dangerouslyInnerHtmlContent--show':
                                    viewMoreMessageText
                                })}
                                dangerouslySetInnerHTML={{ __html: value }}></span>
                            ) : (
                              value
                            )}
                          </li>
                        )
                    )}
                  </ul>
                ) : media.actionType === 'INVITES' ? (
                  <ul className="tmx-analyticsRealTimeMedia__listCOntainer">
                    {media.invitedEmails.map(
                      (email, ind) =>
                        email && (
                          <li className="tmx-analyticsRealTimeMedia__listItems" key={ind}>
                            {email}
                          </li>
                        )
                    )}
                  </ul>
                ) : (
                  <ul
                    className={classNames('tmx-analyticsRealTimeMedia__listCOntainer', {
                      'tmx-analyticsRealTimeMedia__listCOntainer--liveReplies':
                        media.role === 'REPLY' && collectionType === 'live_replies'
                    })}>
                    {collectionType === 'live_signals' ? (
                      <>
                        <li className="tmx-analyticsRealTimeMedia__listItems">
                          <b>{'Search term'}</b>: {media.description}
                        </li>
                        <li className="tmx-analyticsRealTimeMedia__listItems">
                          <b>{'Total searches'}</b>: {media.totalSearches}
                        </li>
                        <li className="tmx-analyticsRealTimeMedia__listItems">
                          <b>{'Users'}</b>: {media.searchUsers}
                        </li>
                      </>
                    ) : (
                      <li className="tmx-analyticsRealTimeMedia__listItems">
                        <p
                          className={classNames('tmx-analyticsRealTimeMedia__messagesPara', {
                            'tmx-analyticsRealTimeMedia__messagesPara--reply':
                              media.role === 'REPLY' && collectionType === 'live_replies',
                            'tmx-analyticsRealTimeMedia__messagesPara--user':
                              media.role === 'USER' && collectionType === 'live_replies'
                          })}>
                          {collectionType === 'live_replies' ? (
                            <Markdown
                              urlTransform={urlTransform}
                              remarkPlugins={[remarkMath, remarkGfm]}>
                              {media.description}
                            </Markdown>
                          ) : (
                            media.description
                          )}
                        </p>
                      </li>
                    )}
                  </ul>
                )}
              </div>
            </div>
            {media?.requestExpert?.Description?.length > 200 &&
              (collectionType === 'Tmx_messages_expert' ||
                collectionType === 'messenger_queue' ||
                collectionType === 'custom_associated_replies' ||
                collectionType === 'replies_to_newsrooms' ||
                collectionType === 'incoming_messages') && (
                <button
                  className="tmx-analyticsRealTimeMedia__viewMoreButton"
                  onClick={() => {
                    setViewMoreMessageText(!viewMoreMessageText);
                    // if(viewMoreMessageText) {
                    var tgtElement = document.getElementById(media?.id);
                    tgtElement.scrollIntoView();
                    // }
                  }}>
                  {viewMoreMessageText ? 'Show Less' : 'View Full Message'}
                </button>
              )}

            {/* {collectionType === 'messenger_queue' &&
              loaded &&
              !loading &&
              !hideSubMediaData &&
              media?.subMediaData?.map((subMedia, ind) => (
                <>
                  <div className="tmx-analyticsRealTimeMedia__divider"></div>
                  <AnalyticsRealTimeMedia
                    // accessUser={accessUser}
                    // requestReplies={requestReplies}
                    // analyticsDashboardCard={analyticsDashboardCard}
                    // liveProfile={liveProfile}
                    setSection={setSection}
                    cardType={1}
                    media={subMedia}
                    loaded={loaded}
                    key={subMedia.id || ind}
                    collectionType={collectionType}
                    loading={loading || !subMedia.id}
                    // redact={redact}
                    hideSubMediaData={true}
                    isSubMediaData={true}></AnalyticsRealTimeMedia>
                </>
              ))} */}
            {requestReplies && (
              <>
                <div className="tmx-analyticsRealTimeMedia__card1TopTextContainer tmx-analyticsRealTimeMedia__card1TopTextContainer--replyToRequest">
                  <div className="tmx-analyticsRealTimeMedia__topCardOrgName tmx-analyticsRealTimeMedia__topCardOrgName--lineClamp tmx-analyticsRealTimeMedia__topCardOrgName--replytorequestTextContainer">
                    {media.replyOrg}{' '}
                    <Icon
                      className="tmx-analyticsRealTimeMedia__verifiedIcon"
                      name="verified"
                      size="micro"
                    />
                  </div>
                  <div className="tmx-analyticsRealTimeMedia__topCardPersonName">
                    {media.replyLocation}
                  </div>
                  <div className="tmx-analyticsRealTimeMedia__topCardPersonName">
                    {media.replyContactName}{' '}
                  </div>
                </div>
                <div className="tmx-analyticsRealTimeMedia__replyOverallContainer">
                  <div className="tmx-analyticsRealTimeMedia__replyOverallTopContainer">
                    <div>
                      <Image
                        className={classNames(
                          'tmx-analyticsRealTimeMedia__replyImage',
                          'tmx-analyticsRealTimeMedia__replyImage--cardType1'
                        )}
                        src={media.replyOrgPic || '/assets/tmx-user-logo.webp'}
                        alt="img"
                        width="100%"
                        height="100%"
                      />
                    </div>
                    <div className="tmx-analyticsRealTimeMedia__replyContentContainer">
                      <div className="tmx-analyticsRealTimeMedia__expertName">
                        {media.replyContactName}
                      </div>
                      <div className="tmx-analyticsRealTimeMedia__expertOccupation">
                        {media.replyOccupation}
                      </div>
                    </div>
                  </div>
                  <div className="tmx-analyticsRealTimeMedia__expertReplyText">
                    {media.replyMessage}
                  </div>
                </div>
              </>
            )}
            {isAccessDashboard && !empty ? (
              <div
                className={classNames('tmx-analyticsRealTimeMedia__accessActionContainer')}
                to={'#'}
                onMouseUp={() => {}}
                onClick={() => {
                  setNewsroomName(media?.companyName);
                  setRequestId(media?.requestId);
                  setShowReplyPanel(true);
                }}
                onKeyDown={() => {
                  setNewsroomName(media?.companyName);
                  setRequestId(media?.requestId);
                  setShowReplyPanel(true);
                }}
                tabIndex={0}
                role="button">
                <div className={classNames('tmx-analyticsRealTimeMedia__sendProfileContainer')}>
                  <Icon
                    name="send-profile"
                    iconSize="fourtyfour"
                    className={classNames(
                      'tmx-analyticsRealTimeMedia__thumbIcon tmx-analyticsRealTimeMedia__thumbIcon--wave'
                    )}
                  />
                  <div className={classNames('tmx-analyticsRealTimeMedia__accessActionText')}>
                    Reply to this request
                  </div>
                </div>
              </div>
            ) : null}
            {collectionType === 'findanyone' && media.action && (
              <>
                <div className="tmx-analyticsRealTimeMedia__divider"></div>
                <div className="tmx-analyticsRealTimeMedia__contactDetailsContainer findAnyone">
                  <div className="tmx-analyticsRealTimeMedia__contactDetailsContainer--actionContainer">
                    <Icon
                      name={
                        media.action === 'FINDANYONE_CALLED'
                          ? 'phone2'
                          : media.action === 'FINDANYONE_EMAILED'
                          ? 'mail'
                          : 'clicked'
                      }
                      size="ginormous"
                    />
                    <p>
                      {media.action === 'FINDANYONE_CALLED'
                        ? 'CALLED'
                        : media.action === 'FINDANYONE_EMAILED'
                        ? 'EMAILED'
                        : 'CLICKED'}
                    </p>
                  </div>
                  <div className="tmx-analyticsRealTimeMedia__contactDetailsContainer--nameContainer findAnyone">
                    <p>{media.contactTitle}</p>
                    <p>
                      {' '}
                      {media.contactType} <span>{media.contactDetail}</span>
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        ) : media.actionType === 'SEARCH' ? (
          <div className="tmx-analyticsRealTimeMedia__searchedTextContainer">
            <Icon
              name="search"
              iconSize="twenty"
              className={classNames('tmx-analyticsRealTimeMedia__thumbIcon', {
                'tmx-analyticsRealTimeMedia__thumbIcon--searched': media.actionType === 'SEARCH'
              })}
            />
            <p className="tmx-analyticsRealTimeMedia__searchedTextDetails">
              Searched for: &quot;{media.searchTerm}&quot; {`${timeNumber}${timeUnit}`} ago
            </p>
          </div>
        ) : isReplyOrCommentSent ? (
          <>
            <div className="tmx-analyticsRealTimeMedia__replyAndCommentSentContainer">
              <div className="tmx-analyticsRealTimeMedia__replyAndCommentSentTimeStamp">
                {`Your ${
                  isCommentSent ? 'Comment' : 'Reply'
                } sent ${`${timeNumber}${timeUnit}`} ago`}
              </div>
              <div className={classNames('tmx-analyticsRealTimeMedia__replyOverallContainer')}>
                <div
                  className={classNames('tmx-analyticsRealTimeMedia__replyOverallTopContainer')}
                  // onClick={() => history.push(`/profile?id=${media?.profileId}`)}
                  // onKeyDown={() => history.push(`/profile?id=${media?.profileId}`)}
                  tabIndex={0}
                  role="button">
                  <div>
                    <Image
                      width="100%"
                      height="100%"
                      className={classNames(
                        'tmx-analyticsRealTimeMedia__image',
                        'tmx-analyticsRealTimeMedia__image--cardType1'
                      )}
                      src={media.profilePic || '/assets/error-profile-image.webp'}
                      alt={'user-profile'}
                    />
                  </div>

                  <div className="tmx-analyticsRealTimeMedia__replyContentContainer">
                    <div className="tmx-analyticsRealTimeMedia__expertName">{media.replyOrg}</div>
                    <div className="tmx-analyticsRealTimeMedia__expertOccupation">
                      {media.replyContactName}
                    </div>
                    <div className="tmx-analyticsRealTimeMedia__expertLocation">
                      {media.replyLocation}
                    </div>
                  </div>
                </div>
                <div className={classNames('tmx-analyticsRealTimeMedia__expertReplyText')}>
                  {media.replyMessage || media.title}
                </div>
              </div>
            </div>
          </>
        ) : isMessages ? (
          <Link
            to="#"
            onMouseDown={() => {
              // if (
              //   media.actionType !== 'HOVER_MESSAGE_REPLY_CARD' &&
              //   media.actionType !== 'VIEW_FULL_MESSAGE' &&
              //   media.action !== 'expert_comment' &&
              //   media.action !== 'quotes'
              // ) {
              //   history.push(`details?cId=${media.mediaId}`);
              // }
            }}
            // to={isMessages ? `details?cId=${media.mediaId}` : '#'}
            className={classNames(
              'tmx-analyticsRealTimeMedia__mainSubContainer--loaded',
              {
                'tmx-analyticsRealTimeMedia__mainSubContainer--noHover tmx-analyticsRealTimeMedia__mainSubContainer--access':
                  isAccessDashboard,
                'tmx-analyticsRealTimeMedia__mainSubContainer--disabled':
                  media.action === 'expert_comment' ||
                  media.action === 'quote' ||
                  media.action === 'quotes' ||
                  media.actionType === 'HOVER_MESSAGE_REPLY_CARD' ||
                  media.actionType === 'VIEW_FULL_MESSAGE'
              },
              {
                'tmx-analyticsRealTimeMedia__mainSubContainer--loaded--isMessages': isMessages
              },
              {
                'tmx-analyticsRealTimeMedia__mainSubContainer--hide': accessUser
              },
              'tmx-analyticsRealTimeMedia__mainSubContainer--messageNewsroom'
            )}>
            {!imgErr && (
              <div className="tmx-analyticsRealTimeMedia__imageWrapper tmx-analyticsRealTimeMedia__imageWrapper--messageNewsroom">
                <Image
                  className={classNames(
                    'tmx-analyticsRealTimeMedia__image tmx-analyticsRealTimeMedia__image--messageNewsroom'
                  )}
                  src={media.thumbnail || '/assets/error-profile-image.webp'}
                  alt="img"
                  onError={(e) => addImageFallback(e, 'thumbnail')}
                  width="100%"
                  height="100%"
                />
              </div>
            )}

            <div className="tmx-analyticsRealTimeMedia__messageNewsroomBottomContainer">
              <div
                className={classNames('tmx-analyticsRealTimeMedia__messageNewsroomTitle', {
                  accessUser: isAccessDashboard
                })}>
                {media.title}
              </div>
              <div>
                {analyticsDashboardCard && (
                  <div className="tmx-analyticsRealTimeMedia__messageNewsroomCompanyName">
                    {media.uploaderCompanyName}
                  </div>
                )}
                {
                  <div className="tmx-analyticsRealTimeMedia__messageNewsroomUserName">
                    {media.uploaderCompanyName}
                  </div>
                }

                <div className="tmx-analyticsRealTimeMedia__messageNewsroomTime">
                  {`${
                    media.action === 'expert_comment' ||
                    media.action === 'quote' ||
                    media.action === 'quotes'
                      ? 'Comment'
                      : media.actionType === 'HOVER_MESSAGE_REPLY_CARD' ||
                        media.actionType === 'VIEW_FULL_MESSAGE'
                      ? 'Reply'
                      : 'Pitch'
                  }  sent ${loginTimeNumber}${loginTimeUnit} ago`}
                </div>
              </div>
            </div>
          </Link>
        ) : (
          <div>
            <Link
              to="#"
              onMouseDown={() => {}}
              className={classNames(
                'tmx-analyticsRealTimeMedia__mainSubContainer--loaded',
                {
                  'tmx-analyticsRealTimeMedia__mainSubContainer--loaded--profileActivity':
                    collectionType === 'profile_activity'
                },
                {
                  'tmx-analyticsRealTimeMedia__mainSubContainer--loaded--isMessages': isMessages
                },
                {
                  'tmx-analyticsRealTimeMedia__mainSubContainer--noHover tmx-analyticsRealTimeMedia__mainSubContainer--access':
                    isAccessDashboard
                },
                {
                  'tmx-analyticsRealTimeMedia__mainSubContainer--hide': accessUser
                },
                {
                  'tmx-analyticsRealTimeMedia__mainSubContainer--redact': redact
                }
              )}>
              {isCardTypeProfileStatus && media?.profileStatus === 'PENDING' ? null : (
                <div className="tmx-analyticsRealTimeMedia__imageWrapper">
                  <Image
                    className={classNames('tmx-analyticsRealTimeMedia__image')}
                    src={
                      (collectionType === 'profile_activity'
                        ? media.profilePic
                        : media.thumbnail) || '/assets/error-profile-image.webp'
                    }
                    alt="img"
                    onError={addImageFallback}
                    width="100%"
                    height="100%"
                  />
                </div>
              )}

              <div
                className={classNames('tmx-analyticsRealTimeMedia__cardDetailsContainer', {
                  profileActivity: collectionType === 'profile_activity',
                  liveProfile:
                    collectionType === 'profile_activity' && media?.profileStatus === 'APPROVED'
                })}>
                <div
                  className={classNames('tmx-analyticsRealTimeMedia__title', {
                    profileActivity: collectionType === 'profile_activity',
                    'tmx-analyticsRealTimeMedia__title--profileStatus':
                      isCardTypeProfileStatus && media?.profileStatus === 'PENDING'
                  })}>
                  {collectionType === 'profile_activity' || isAccessDashboard
                    ? media.contactName
                    : media.title}
                  {isCardTypeProfileStatus &&
                  media?.profileStatus === 'PENDING' ? null : collectionType ===
                    'profile_activity' ? (
                    <>
                      <div className={classNames('tmx-analyticsRealTimeMedia__occupation')}>
                        {media.occupation}
                      </div>
                    </>
                  ) : null}
                </div>

                <div
                  className={classNames(
                    'tmx-analyticsRealTimeMedia__absoluteContainer',
                    {
                      'tmx-analyticsRealTimeMedia__absoluteContainer--loading': loading
                    },
                    {
                      'tmx-analyticsRealTimeMedia__absoluteContainer--hide': isAccessDashboard
                    }
                  )}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <>
                      <div
                        className={classNames('tmx-analyticsRealTimeMedia__profileTitle', {
                          hide: isMessages
                        })}>
                        <span className="tmx-analyticsRealTimeMedia__permissionLikely">
                          <Icon
                            name={
                              media.actionType === 'INTERESTED'
                                ? 'thumb-up'
                                : media.actionType === 'NOT INTERESTED'
                                ? 'thumb-down'
                                : media.actionType === 'VIEW' ||
                                  (collectionType === 'profile_activity' && !liveProfile)
                                ? 'views'
                                : collectionType === 'profile_activity'
                                ? 'title-shared'
                                : media.actionType === 'COPIED'
                                ? 'send-request-2'
                                : media.actionType === 'VIEWED MORE'
                                ? 'read-entire'
                                : media.actionType === 'EMBED'
                                ? 'link-solid'
                                : media.actionType === 'DOWNLOAD'
                                ? 'cloud-download'
                                : media.actionType === 'SEARCH'
                                ? 'search'
                                : media.actionType === 'INVITES'
                                ? 'contacts'
                                : ''
                            }
                            iconSize="twenty"
                            className={classNames(
                              'tmx-analyticsRealTimeMedia__thumbIcon',
                              {
                                'tmx-analyticsRealTimeMedia__thumbIcon--interested':
                                  media.actionType === 'INTERESTED'
                              },
                              {
                                'tmx-analyticsRealTimeMedia__thumbIcon--notInterested':
                                  media.actionType === 'NOT INTERESTED'
                              },
                              {
                                'tmx-analyticsRealTimeMedia__thumbIcon--viewed':
                                  media.actionType === 'VIEW' ||
                                  media.actionType === 'SEARCH' ||
                                  collectionType === 'profile_activity'
                              },
                              {
                                'tmx-analyticsRealTimeMedia__thumbIcon--copied':
                                  media.actionType === 'COPIED'
                              },
                              {
                                'tmx-analyticsRealTimeMedia__thumbIcon--viewedMore':
                                  media.actionType === 'VIEWED MORE'
                              },
                              {
                                'tmx-analyticsRealTimeMedia__thumbIcon--copiedEmbed':
                                  media.actionType === 'EMBED'
                              },
                              {
                                'tmx-analyticsRealTimeMedia__thumbIcon--downloaded':
                                  media.actionType === 'DOWNLOAD'
                              }
                            )}
                          />
                          <p className={classNames('tmx-analyticsRealTimeMedia__creator')}>
                            {isReplyOrCommentSent
                              ? 'New Request Sent '
                              : media.actionType === 'INTERESTED'
                              ? 'Interested'
                              : media.actionType === 'NOT INTERESTED'
                              ? 'Not Interested'
                              : media.actionType === 'VIEW' && collectionType !== 'profile_activity'
                              ? 'Viewed'
                              : media.actionType === 'OPEN' && collectionType !== 'profile_activity'
                              ? 'Opened'
                              : media.actionType === 'STORY_CONTACT_CALLED' &&
                                collectionType !== 'profile_activity'
                              ? 'Called'
                              : media.actionType === 'STORY_CONTACT_EMAILED' &&
                                collectionType !== 'profile_activity'
                              ? 'Emailed'
                              : media.actionType === 'COPIED'
                              ? 'Copied'
                              : media.actionType === 'VIEWED MORE'
                              ? 'Viewed more'
                              : media.actionType === 'EMBED'
                              ? 'Copied Embed'
                              : media.actionType === 'DOWNLOAD'
                              ? 'Downloaded'
                              : media.actionType === 'SEARCH'
                              ? 'Searched'
                              : media.actionType === 'INVITES'
                              ? 'Invited'
                              : collectionType === 'profile_activity' && liveProfile
                              ? 'Profile created'
                              : collectionType === 'profile_activity'
                              ? 'Viewed your profile'
                              : ''}{' '}
                            {`${timeNumber}${timeUnit}`} ago
                          </p>
                        </span>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </Link>
            {collectionType === 'contacts' && media.action && (
              <>
                <div className="tmx-analyticsRealTimeMedia__divider"></div>
                <div className="tmx-analyticsRealTimeMedia__contactDetailsContainer">
                  <div className="tmx-analyticsRealTimeMedia__contactDetailsContainer--actionContainer">
                    <Icon
                      name={media.action === 'STORY_CONTACT_CALLED' ? 'phone2' : 'mail'}
                      size="ginormous"
                    />
                    <p>{media.action === 'STORY_CONTACT_CALLED' ? 'CALLED' : 'EMAILED'}</p>
                  </div>
                  <div className="tmx-analyticsRealTimeMedia__contactDetailsContainer--nameContainer">
                    <p>{media.contactTitle}</p>
                    <p>
                      {' '}
                      {media.contactType} <span>{media.contactDetail}</span>
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        )
      ) : (
        <div className="tmx-analyticsRealTimeMedia__bottomSectionMock"></div>
      )}
    </div>
  ) : cardType === 0 && !empty ? (
    <div className={mediaClassName}>
      <div className="tmx-analyticsRealTimeMedia__topCardContainer tmx-analyticsRealTimeMedia__topCardContainer--cardType0">
        <div className="tmx-analyticsRealTimeMedia__cardType0ImageTitleContainer">
          {!loading && media.orgPic ? (
            <div
              className="tmx-analyticsRealTimeMedia__profilePicContainerHoverState"
              onClick={() => {
                setShowCardType1Modal(true);
              }}
              onKeyDown={() => {
                setShowCardType1Modal(true);
              }}
              tabIndex={0}
              role="button">
              <div className="tmx-analyticsRealTimeMedia__profilePicContainer">
                <Image
                  className={classNames('tmx-analyticsRealTimeMedia__orgPic')}
                  src={media.orgPic}
                  alt="img"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          ) : (
            <div
              className="tmx-analyticsRealTimeMedia__imgErrHoverState"
              onClick={() => {
                setShowCardType1Modal(true);
              }}
              onKeyDown={() => {
                setShowCardType1Modal(true);
              }}
              tabIndex={0}
              role="button">
              <div
                className={classNames(
                  'tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--type0ProfileCircle tmx-analyticsRealTimeMedia__titleMock--imgErr',
                  {
                    'tmx-analyticsRealTimeMedia__titleMock--loading': loading
                  }
                )}>
                {initial}
              </div>
            </div>
          )}

          <div
            className="tmx-analyticsRealTimeMedia__topCardOrgNameContainer"
            tabIndex={0}
            role="button">
            {!loading ? (
              <div
                className={classNames('tmx-analyticsRealTimeMedia__topCardOrgName', {
                  'tmx-analyticsRealTimeMedia__topCardOrgName--disableHover': isAccessDashboard
                })}
                onClick={() => {
                  // setShowDeleteModal(true);
                }}
                onKeyDown={() => {
                  // setShowDeleteModal(true);
                }}
                tabIndex={0}
                role="button">
                {media.companyName}{' '}
                <Icon
                  className="tmx-analyticsRealTimeMedia__verifiedIcon"
                  name="verified"
                  size="micro"
                />
              </div>
            ) : (
              <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--type0Org"></div>
            )}
            {!loading ? (
              media.isLoggedIn ? (
                <div
                  className={classNames('tmx-analyticsRealTimeMedia__onlineContainer', {
                    'tmx-analyticsRealTimeMedia__onlineContainer--tracker': isOnTrackerTab
                  })}>
                  <Tooltip direction="left" content="Online">
                    <div className="tmx-analyticsRealTimeMedia__onlineCircle tmx-analyticsRealTimeMedia__onlineCircle--cardType0"></div>
                  </Tooltip>
                  <Tooltip direction="left" content={media.deviceType}>
                    <div className="tmx-analyticsRealTimeMedia__onlineFont">{media.deviceType}</div>
                  </Tooltip>
                </div>
              ) : (
                <Tooltip direction="left" content="Offline">
                  <div className="tmx-analyticsRealTimeMedia__onlineCircle tmx-analyticsRealTimeMedia__onlineCircle--offLineCardType0"></div>
                </Tooltip>
              )
            ) : (
              <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--onlineCircle tmx-analyticsRealTimeMedia__titleMock--cardType0"></div>
            )}
          </div>
        </div>
        <div
          className="tmx-analyticsRealTimeMedia__cardType0SubContainer"
          onClick={() => {
            callCustomCollectionManually(media.email);
          }}
          onKeyDown={() => {
            callCustomCollectionManually(media.email);
          }}
          tabIndex={0}
          role="button">
          <div className="tmx-analyticsRealTimeMedia__cardType0SubInnerContainer">
            {!loading ? (
              <div className="tmx-analyticsRealTimeMedia__topCardPersonName tmx-analyticsRealTimeMedia__topCardPersonName--cardType0">
                {media.contactName}{' '}
              </div>
            ) : (
              <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--type0Name"></div>
            )}
            {!loading ? (
              <div className="tmx-analyticsRealTimeMedia__topCardEmail tmx-analyticsRealTimeMedia__topCardEmail--cardType0">
                {media.email}
              </div>
            ) : (
              <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--type0Email"></div>
            )}

            {!loading ? (
              <div className="tmx-analyticsRealTimeMedia__topCardEmail tmx-analyticsRealTimeMedia__topCardEmail--cardType0">
                {`${
                  collectionType === 'new_users' ? 'Created' : 'Active'
                } ${timeNumber}${timeUnit}`}{' '}
                ago
              </div>
            ) : (
              <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--type0Time"></div>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : cardType === 2 && !empty ? (
    <div className={mediaClassName}>
      <div className="tmx-analyticsRealTimeMedia__topCardContainer tmx-analyticsRealTimeMedia__topCardContainer--cardType0">
        <div
          className={classNames(
            'tmx-analyticsRealTimeMedia__cardType0ImageTitleContainer tmx-analyticsRealTimeMedia__cardType0ImageTitleContainer--cardType2',
            {
              'tmx-analyticsRealTimeMedia__cardType0ImageTitleContainer--access': isAccessDashboard
            }
          )}>
          {!loading && media.orgPic ? (
            <div
              className={classNames(
                'tmx-analyticsRealTimeMedia__profilePicContainerHoverState tmx-analyticsRealTimeMedia__profilePicContainerHoverState--cardType2',
                {
                  'tmx-analyticsRealTimeMedia__profilePicContainerHoverState--disableHover':
                    isAccessDashboard && collectionType !== 'new_journalists'
                }
              )}
              onClick={() => {
                // if (collectionType === 'new_journalists' && isAccessDashboardPremium) {
                //   setShowMessageNewsroomPanel(true);
                // } else if (!blockClick) {
                //   history.push('/plansandpricing');
                // }
                // if (notAccessDashboard) {
                //   setShowCardType1Modal(true);
                // }
              }}
              onKeyDown={() => {
                // if (collectionType === 'new_journalists' && isAccessDashboardPremium) {
                //   setShowMessageNewsroomPanel(true);
                // } else if (!blockClick) {
                //   history.push('/plansandpricing');
                // }
                // if (notAccessDashboard) {
                //   setShowCardType1Modal(true);
                // }
              }}
              tabIndex={0}
              role="button">
              <div className="tmx-analyticsRealTimeMedia__profilePicContainer tmx-analyticsRealTimeMedia__profilePicContainer--cardType2">
                <Image
                  className={classNames(
                    'tmx-analyticsRealTimeMedia__orgPic tmx-analyticsRealTimeMedia__orgPic--cardType2'
                  )}
                  src={media.orgPic}
                  alt="img"
                  height="100%"
                  width="100%"
                />
              </div>
            </div>
          ) : (
            <div
              className={classNames(
                'tmx-analyticsRealTimeMedia__imgErrHoverState tmx-analyticsRealTimeMedia__imgErrHoverState--cardType2',
                {
                  'tmx-analyticsRealTimeMedia__imgErrHoverState--disableHover':
                    isAccessDashboard && collectionType !== 'new_journalists'
                }
              )}
              onClick={() => {
                // if (collectionType === 'new_journalists' && isAccessDashboardPremium) {
                //   setShowMessageNewsroomPanel(true);
                // } else {
                //   history.push('/plansandpricing');
                // }
                // if (notAccessDashboard) {
                //   setShowCardType1Modal(true);
                // }
              }}
              onKeyDown={() => {
                // if (collectionType === 'new_journalists' && isAccessDashboardPremium) {
                //   setShowMessageNewsroomPanel(true);
                // } else {
                //   history.push('/plansandpricing');
                // }
                // if (notAccessDashboard) {
                //   setShowCardType1Modal(true);
                // }
              }}
              tabIndex={0}
              role="button">
              <div
                className={classNames(
                  'tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--type0ProfileCircle tmx-analyticsRealTimeMedia__titleMock--cardType2 tmx-analyticsRealTimeMedia__titleMock--imgErr',
                  {
                    'tmx-analyticsRealTimeMedia__titleMock--loading': loading
                  }
                )}>
                {initial}
              </div>
            </div>
          )}

          <div
            className="tmx-analyticsRealTimeMedia__topCardOrgNameContainer"
            tabIndex={0}
            role="button">
            {!loading ? (
              <div>
                <div
                  className={classNames(
                    'tmx-analyticsRealTimeMedia__topCardOrgName tmx-analyticsRealTimeMedia__topCardOrgName--lineClamp',
                    {
                      'tmx-analyticsRealTimeMedia__topCardOrgName--disableHover': isAccessDashboard
                    }
                  )}
                  onClick={() => {
                    // setShowDeleteModal(true);
                  }}
                  onKeyDown={() => {
                    // setShowDeleteModal(true);
                  }}
                  tabIndex={0}
                  role="button">
                  {media.companyName}{' '}
                  <Icon
                    className="tmx-analyticsRealTimeMedia__verifiedIcon"
                    name="verified"
                    size="micro"
                  />
                </div>
                <div className="tmx-analyticsRealTimeMedia__locationFont">{media.location}</div>
                <Tooltip direction="left" content="Online" hideTooltip={isAccessDashboard}>
                  <div className="tmx-analyticsRealTimeMedia__journalistActiveContainer">
                    <div className="tmx-analyticsRealTimeMedia__onlineCircle tmx-analyticsRealTimeMedia__onlineCircle--offLine"></div>
                    <div className="tmx-analyticsRealTimeMedia__journalistActiveText">
                      {isAccessDashboard ? 'Journalist -' : 'Journalist active'} {loginTimeNumber}
                      {loginTimeUnit} ago
                    </div>
                  </div>
                </Tooltip>
              </div>
            ) : (
              <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--type0Org"></div>
            )}
            {!loading ? (
              media.isLoggedIn ? (
                <div
                  className={classNames(
                    'tmx-analyticsRealTimeMedia__onlineContainer',
                    {
                      'tmx-analyticsRealTimeMedia__onlineContainer--tracker': isOnTrackerTab
                    },
                    {
                      'tmx-analyticsRealTimeMedia__onlineContainer--hide': isAccessDashboard
                    }
                  )}>
                  <Tooltip direction="left" content="Online">
                    <div className="tmx-analyticsRealTimeMedia__onlineCircle tmx-analyticsRealTimeMedia__onlineCircle--cardType0"></div>
                  </Tooltip>
                  <Tooltip direction="left" content={media.deviceType}>
                    <div className="tmx-analyticsRealTimeMedia__onlineFont">{media.deviceType}</div>
                  </Tooltip>
                </div>
              ) : (
                <Tooltip direction="left" content="Offline">
                  <div
                    className={classNames(
                      'tmx-analyticsRealTimeMedia__onlineCircle tmx-analyticsRealTimeMedia__onlineCircle--offLineCardType2',
                      {
                        'tmx-analyticsRealTimeMedia__onlineCircle--access': isAccessDashboard
                      }
                    )}></div>
                </Tooltip>
              )
            ) : (
              <div className="tmx-analyticsRealTimeMedia__titleMock tmx-analyticsRealTimeMedia__titleMock--onlineCircle tmx-analyticsRealTimeMedia__titleMock--cardType0"></div>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : empty && !loading ? (
    <div className={mediaClassName}>
      <div className="tmx-analyticsRealTimeMedia__emptyText">{emptyString}</div>
    </div>
  ) : null;
};

AnalyticsRealTimeMedia.propTypes = {
  accessUser: PropTypes.bool,
  analyticsDashboardCard: PropTypes.bool,
  cardType: PropTypes.number,
  className: PropTypes.string,
  collectionType: PropTypes.string,
  dashboardType: PropTypes.string,
  empty: PropTypes.bool,
  emptyString: PropTypes.string,
  liveProfile: PropTypes.bool,
  loaded: PropTypes.bool,
  loading: PropTypes.bool,
  media: PropTypes.shape({
    contactDetail: PropTypes.string,
    contactType: PropTypes.string,
    contactTitle: PropTypes.string,
    uploadTime: PropTypes.string,
    uploaderName: PropTypes.string,
    uploaderCompanyName: PropTypes.string,
    action: PropTypes.string,
    actionType: PropTypes.string,
    profilePic: PropTypes.string,
    occupation: PropTypes.string,
    location: PropTypes.string,
    companyName: PropTypes.string,
    contactName: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isLoggedIn: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    lastLogin: PropTypes.string,
    mediaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    orgPic: PropTypes.string,
    state: PropTypes.string,
    thumbnail: PropTypes.string,
    time: PropTypes.string,
    timestamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,
    type: PropTypes.string,
    userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    searchTerm: PropTypes.string,
    description: PropTypes.string,
    invitedEmails: PropTypes.array,
    searchedFields: PropTypes.shape({
      AKAS: PropTypes.string,
      'Address line 1': PropTypes.string,
      'Address line 2': PropTypes.string,
      'Age range': PropTypes.string,
      'Date of birth': PropTypes.string,
      'First name': PropTypes.string,
      'Last name': PropTypes.string,
      'Middle name': PropTypes.string,
      Phone: PropTypes.string
    }),
    requestExpert: PropTypes.shape({
      Purpose: PropTypes.string,
      'Show Name': PropTypes.string,
      'Shooting Preference': PropTypes.string,
      'Type of expert': PropTypes.string,
      'Topics that will be discussed': PropTypes.string,
      'Additional info (optional)': PropTypes.string
    }),
    deviceType: PropTypes.string,
    name: PropTypes.string,
    requestId: PropTypes.any,
    profileStatus: PropTypes.string,
    profileId: PropTypes.string,
    profileCreatorName: PropTypes.string,
    replyMessage: PropTypes.string,
    replyContactName: PropTypes.string,
    replyOrg: PropTypes.string,
    replyLocation: PropTypes.string,
    replyOccupation: PropTypes.string,
    replyOrgPic: PropTypes.string,
    uploaderLocation: PropTypes.string
  }),
  requestReplies: PropTypes.bool,
  setNewsroomName: PropTypes.func,
  setRequestId: PropTypes.func,
  setSection: PropTypes.func,
  setShowMessageNewsroomPanel: PropTypes.func,
  setShowReplyPanel: PropTypes.func,
  redact: PropTypes.bool,
  blockClick: PropTypes.bool,
  hideSubMediaData: PropTypes.bool,
  isSubMediaData: PropTypes.bool,
  callCustomCollectionManually: PropTypes.func,
  updateNewsroomRequestStatus: PropTypes.func
};

AnalyticsRealTimeMedia.defaultProps = {
  redact: false,
  blockClick: false,
  hideSubMediaData: true,
  isSubMediaData: false
};

export default AnalyticsRealTimeMedia;
